<template>
  <wrapper project="users" :request="searchData" :params="params">
    <template slot="toolbar" slot-scope="scope">
      <tg-search-tool :data="searchData" @on-submit="handleSearch(scope.onSearch)">
        <el-input
          :placeholder="$t('component.form.input.placeholder.member')"
          v-model="searchData.targetName"
          class="tg-input input-search-username"
          clearable
          size="small"
        ></el-input>
      </tg-search-tool>
    </template>
    <template slot="link" slot-scope="scope">
      <a v-if="scope.value > 0" @click.prevent="handleGoToDetail(scope)" href>
        {{
        scope.formated
        }}
      </a>
      <span v-else>{{ scope.formated }}</span>
    </template>
  </wrapper>
</template>

<script>
import wrapper from "./wrapper";
import TgSearchTool from "@/components/tool/TgSearchTool";
import minins from "./mixins";

export default {
  components: {
    wrapper,
    TgSearchTool,
  },
  mixins: [minins],
  methods: {
    handleGoToDetail(scope) {
      let username = scope.row["username"];
      let keyData = {
        event: this.params.event,
        game_time: this.params.game_time,
        username,
      };

      let upper_agent = {};

      [20, 40, 60, 70].forEach((g) => {
        let k = "l" + g;
        let col_id = k + "_id";

        if (col_id in scope.row) {
          upper_agent[k] = scope.row[col_id];
        }
      });

      let params = {
        ...this.params,
        ...keyData,
        usernickname: scope.row["usernickname"],
        reward: scope.column.reward,
        title: scope.column.title,
        upper_agent,
      };

      let historyKey = this.$history.add(params, keyData);

      this.$router.push({
        name: "tg_business.reward-record.member.detail",
        params: { username },
        query: { h: historyKey },
      });
    },
  },
};
</script>
